module.exports = __webpack_public_path__ + "static/media/close.190e4dc8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/display/components/SearchGroup/Icon/close.svg
// module id = 4371
// module chunks = 0